import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

import {
  NavigationEnd,
  Router
} from '@angular/router';

import { filter } from 'rxjs/operators';

import {
  Empty_Nav_Interface,
  Nav_Interface
} from 'src/app/Interface/Nav_Interface';

import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-Nav',
  templateUrl: './Nav.component.html',
  styleUrls: ['./Nav.component.scss']
})
export class NavComponent implements OnInit {

  @Input() collapsed = false;
  @Output() expandRequested = new EventEmitter<void>();

  Type: string = "0";

  Data_Menu: Array<Nav_Interface> = [];

  NewTickerCount: number = 0;


  constructor(
    private Nav_Service: NavService,
    private router: Router
  ) { }


  ngOnInit() {

    this.Type = localStorage.getItem('Daro_User_Type') || "0";

    const storedNav = localStorage.getItem('Daro_User_Nav');

    if (storedNav) {
      try {
        this.Data_Menu = JSON.parse(storedNav) || [];
      }
      catch {
        this.Data_Menu = [];
      }
    }
    else {
      this.Data_Menu = [];
    }

    // ساختار Parent / Child منوها
    this.Data_Menu = this.FilterNav(0);

    // هیچ منویی در شروع به صورت خودکار باز نمی‌شود
    for (const item of this.Data_Menu) {
      item.visible = false;
    }

    // فقط Parent مربوط به صفحه فعلی باز شود
    this.OpenActiveGroup();

    // هنگام تغییر Route، Parent مربوط به Route جدید باز شود
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(() => {
        this.OpenActiveGroup();
      });

    this.GetNotice();
  }


  Read_Data() {

    this.Nav_Service.Get().subscribe(
      data => {

        this.Data_Menu = data['result'] || [];

        this.NewTickerCount = data['new_Ticket'] || 0;

        // ساخت مجدد ساختار Parent / Child
        this.Data_Menu = this.FilterNav(0);

        // همه منوها در ابتدا بسته باشند
        for (const item of this.Data_Menu) {
          item.visible = false;
        }

        // محاسبه Notificationها
        this.FilterNavParent();

        // فقط گروه مربوط به Route فعلی باز شود
        this.OpenActiveGroup();

      },
      error => {

        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    );
  }


  FilterNav(id: Number): Array<Nav_Interface> {
    var tempList: Array<Nav_Interface> = []

    for (let item of this.Data_Menu) {
      if (item.parent == id) {
        var temp: Nav_Interface = Empty_Nav_Interface()

        temp.id = item.id
        temp.icon = item.icon
        temp.link = item.link
        temp.parent = item.parent
        temp.title = item.title
        temp.count = 0
        temp.visible = false
        temp.child = this.FilterNav(item.id)

        if (item.id == 1102 || item.id == 1104) {
          temp.count = this.NewTickerCount
        }

        tempList.push(temp)
      }
    }

    return tempList
  }


  getMenuIcon(item: Nav_Interface): string {

    const icon = (item.icon || '').trim();

    // منوهایی که آیکون ندارند
    if (!icon) {
      return 'fa fa-list';
    }

    // اگر Backend مقدار نامعتبر یا مقدار قدیمی برگرداند
    const validPrefixes = [
      'fa ',
      'fa-',
      'ti-',
      'glyphicon',
      'mdi',
      'icon-'
    ];

    const isValidFormat = validPrefixes.some(prefix =>
      icon.startsWith(prefix)
    );

    if (!isValidFormat) {
      return 'fa fa-list';
    }

    return icon;
  }

  FilterNavParent() {
    if (this.Type == '1' || this.Type == '2') {
      for (let item1 of this.Data_Menu) {
        item1.count = 0

        for (let item2 of item1.child) {
          if (item2.count > 0 || item2.new)
            item1.count = 5
        }
      }
    }
  }



  OpenActiveGroup() {

    const currentPath = this.GetCurrentPath();

    for (const item of this.Data_Menu) {

      // ابتدا همه بسته
      item.visible = false;

      const hasActiveChild = item.child?.some(child => {

        if (!child.link) {
          return false;
        }

        const childPath = child.link.split(/[?;]/)[0];

        return currentPath === childPath;

      });

      if (hasActiveChild) {
        item.visible = true;
      }
    }
  }


  /**
   * مسیر فعلی بدون QueryString و Fragment
   */
  private GetCurrentPath(): string {

    return this.router.url.split(/[?;]/)[0];

  }


  Change_Visible_Menu(item: Nav_Interface) {

    item.visible = !item.visible;

  }


  toggleMenu(item: Nav_Interface): void {

    // اگر Sidebar جمع شده است
    if (this.collapsed) {

      // Sidebar را باز کن
      item.visible = true;

      this.expandRequested.emit();

      return;
    }

    // در حالت عادی فقط با کلیک کاربر باز / بسته شود
    this.Change_Visible_Menu(item);

  }


  isGroupActive(item: Nav_Interface): boolean {

    const currentPath = this.GetCurrentPath();

    return item.child?.some(child => {

      if (!child.link) {
        return false;
      }

      const childPath = child.link.split(/[?;]/)[0];

      return currentPath === childPath;

    }) || false;

  }


  Set_Count_Zero(item: Nav_Interface) {

    this.GetNotice();

  }


  GetNotice() {

    this.Nav_Service.GetNotice().subscribe(
      data => {

        for (const nav of data) {

          for (const lvl1 of this.Data_Menu) {

            for (const lvl2 of lvl1.child) {

              if (nav['id'] == lvl2.id) {

                lvl2.count = nav['parent'];
                lvl2.new = nav['orderMenu'];

              }

            }
          }
        }

        // فقط Countها محاسبه شوند.
        // این متد دیگر visible را تغییر نمی‌دهد.
        this.FilterNavParent();

      }
    );
  }

}
